]
<!-- =========================================================================================
    File Name: Faq.vue
    Description: FAQ Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="flex w-full bg-search vx-row no-gutter items-center justify-center">
		<div class="vx-col sm:w-1/1 md:w-1/1 lg:w-3/4 xl:w-3/5 sm:m-0 m-4 p-2">
			<vx-card style="min-height: 350px">
				<div slot="no-body" class="full-page-bg-color">
					<div class="vx-row no-gutter justify-center items-center">
						<div class="vx-col hidden lg:block lg:w-1/2">
							<img
								src="@/assets/images/pages/rutify/1-03.png"
								alt="login"
								class="mx-auto img-datarutas"
								:style="`width:${result}px; top: ${top}%; left: ${left}%; position:${position};`"
							/>
							<transition name="bounce">
								<div v-if="showBrand" class="text-center">
									<img :src="companyBrand" alt="login" class="mx-auto img-company-brand" />
									<h1 class="mt-2 font-bold">{{ companyName }}</h1>
								</div>
							</transition>
						</div>

						<div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
							<div class="px-8 pt-8 login-tabs-container">
								<div class="mb-4">
									<h4 class="mb-4">{{ translation("EventTracking") }}</h4>
									<p>{{ translation("TrackingText") }}</p>
								</div>

								<vs-tabs>
									<vs-tab :label="translation('Tracking')">
										<div v-if="notFound">
											<vs-alert
												icon-pack="feather"
												icon="icon-info"
												class="h-full my-4"
												color="warning"
											>
												<span>{{ translation("EventNotFoundText") }} </span>
											</vs-alert>
										</div>

										<div class="mt-4 mb-base">
											<div class="flex flex-col gap-2">
												<vs-input
													:placeholder="translation('TrackingCode')"
													v-model="eventUuid"
													icon-pack="feather"
													icon="icon-search"
													size="large"
													class="w-full"
													icon-no-border
													v-validate="'alpha_num|min:1'"
													name="eventUuid"
												/>

												<span class="text-danger text-sm" v-show="errors.has('eventUuid')">
													{{ translation("AlphaNumeric") }}
												</span>

												<vs-button
													class="w-full lg:w-auto md:w-auto"
													size="large"
													@click="trackEvent"
													:disabled="eventUuid.length < 1"
													>{{ translation("EventStatusBtn") }}</vs-button
												>
											</div>
										</div>
									</vs-tab>
								</vs-tabs>
							</div>
						</div>

						<div lass="vx-col">
							<div v-if="eventData && !notFound">
								<div class="p-4 md:p-1">
									<h4 class="mb-2">
										{{ translation("EventDetails") }}
									</h4>

									<p>
										{{ translation("EventDetailsText") }}
									</p>
								</div>

								<div class="flex justify-end">
									<vs-button
										type="flat"
										class="mt-4 mr-3"
										icon-pack="feather"
										icon="icon icon-file"
										@click="print"
										>{{ translation("Print") }}</vs-button
									>
								</div>

								<vs-divider />

								<div class="p-4 md:p-1">
									<h4>ID {{ eventData.event_uuid }}</h4>

									<p class="my-2">
										<span class="mr-2">{{ $t("Address") }}: </span>
										<span>{{ fullAddress }}</span>
									</p>
									<p class="flex items-center flex-wrap" v-if="eventData.ETA_to_next_point">
										<span class="text-2xl leading-none font-medium text-primary mr-4 mt-2">{{
											eventData.ETA_to_next_point
										}}</span>

										<span class="cursor-pointer leading-none mt-2">{{
											translation("EstimatedTimeArrivalNextStop")
										}}</span>
									</p>

									<vs-divider />

									<p>{{ translation("EventScheduleInformation") }}</p>

									<vs-list class="product-sales-meta-list px-0 pt-4">
										<vs-list-item
											class="border-none"
											:title="eventData.schedule_date"
											:subtitle="translation('ScheduleDate')"
											icon-pack="feather"
											icon="icon-calendar"
										/>
										<vs-list-item
											class="border-none"
											:title="eventData.schedule_init_hour"
											:subtitle="translation('ScheduleInitHour')"
											icon-pack="feather"
											icon="icon-clock"
										/>

										<vs-list-item
											class="border-none"
											:title="eventData.schedule_end_hour"
											:subtitle="translation('ScheduleEndHour')"
											icon-pack="feather"
											icon="icon-clock"
										/>
									</vs-list>
								</div>

								<vs-divider />

								<div class="p-4 md:p-1">
									<h4>{{ translation("Updates") }}</h4>
									<vs-collapse>
										<vs-collapse-item>
											<div slot="header">
												{{ translation("TrackingHistory") }}
											</div>

											<vx-timeline :data="eventHistoryComputed" />
										</vs-collapse-item>

										<vs-collapse-item>
											<div slot="header">{{ translation("NextStops") }}</div>
											<vx-timeline :data="waypoints" />
										</vs-collapse-item>
									</vs-collapse>
								</div>

								<vs-divider />

								<div class="my-5">
									<vs-pagination :total="total" v-model="currentx" :max="6"></vs-pagination>
								</div>
							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
// Store Modules
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import VxTimeline from "@/components/timeline/VxTimeline";
import EventHistory from "../../models/EventHistory";

export default {
	data() {
		return {
			eventUuid: "",
			events: [],
			eventData: null,
			notFound: false,
			faqFilter: 1,
			showBrand: false,
			result: 250,
			top: 0,
			left: 0,
			position: "relative",
			eventHistory: [],
			waypoints: [],
			companyBrand: require("@/assets/images/pages/1-apex.png"),
			companyName: "",
			currentx: 1,
			total: 1,
		};
	},
	computed: {
		filteredFaq() {
			return this.faqs;
		},
		eventHistoryComputed() {
			return this.eventHistory;
		},
		fullAddress() {
			return `${this.eventData.address}, ${this.eventData.city}, ${this.eventData.department}, ${this.eventData.country}`;
		},

		translation() {
			return function (label) {
				return this.$t(`EventTracking.${label}`);
			};
		},
		validateAlphanumericString() {
			const pattern = /^[a-zA-Z0-9]{1}$/;
			return pattern.test(this.eventUuid);
		},
	},
	methods: {
		async trackEvent() {
			this.clearPage();
			this.$vs.loading();
			const response = await this.$store.dispatch("moduleSchedule/eventTracking", this.eventUuid);

			if (response.status === 200) {
				const {company_logo, company_name, events, ...rest} = response.data;

				this.events = [...events];
				this.total = events.length;

				if (this.total > 0) {
					this.currentx = 1;

					this.eventData = this.events[0];

					const {event_history, waypoints} = this.eventData;

					this.eventHistory = event_history.map((event, index) => {
						const eh = new EventHistory(
							event.added_on,
							this.eventText(event.event_status_name),
							event.added_on,
							event.event_status_name
						);
						eh.title = eh.formatDateToString(event.added_on);
						return eh;
					});

					this.waypoints = waypoints.map((waypoint) => {
						const eh = new EventHistory(
							waypoint.ETA,
							this.eventText(waypoint.event_status_name),
							"#" + waypoint.order,
							waypoint.event_status_name
						);

						return eh;
					});

					if (company_logo) {
						this.updateCompanyBrand({text: company_name, url_logo: company_logo});
					} else {
						this.resetAnimation();
					}
				}
			} else {
				this.notFound = true;
			}

			this.$vs.loading.close();
		},
		updateCompanyBrand({text, url_logo}) {
			if (!url_logo) return;
			this.companyBrand = url_logo;
			this.companyName = text ? text : "";
			this.runAnimation();
			setTimeout(() => {
				this.showBrand = true;
				this.position = "absolute";
			}, 500);
		},
		runAnimation() {
			this.result = 50;
			this.top = 5;
			this.left = 5;
		},
		resetAnimation() {
			this.companyName = "";
			this.showBrand = false;
			setTimeout(() => {
				this.result = 250;
				this.top = 0;
				this.left = 0;
				this.position = "relative";
			}, 700);
		},
		print() {
			window.print();
		},
		eventText(status) {
			let text = "";
			switch (status) {
				case "ASSIGNED":
					text = this.$t("Schedule.Scheduled");
					break;
				case "RESCHEDULED":
				case "REPROGRAMMED":
					text = this.$t("Schedule.ReProgramming");
					break;
				case "DELAYED":
					text = this.$t("Schedule.Delayed");
					break;
				case "ON THE WAY":
					text = this.$t("Schedule.OnTheWay");
					break;
				case "IN PROGRESS":
					text = this.$t("Schedule.InProgress");
					break;
				case "FINALIZED":
					text = this.$t("Schedule.Finished");
					break;
				case "CANCELLED":
					text = this.$t("Schedule.Canceled");
					break;
				case "NOT ASSIGNED":
					text = this.$t("Schedule.NotAssigned");
					break;
				default:
					text = status;
					break;
			}
			return text;
		},
		clearPage() {
			this.eventData = null;
			this.notFound = false;
			this.eventHistory = [];
			this.waypoints = [];
		},
	},
	components: {
		VxTimeline,
	},
	watch: {
		currentx(val) {
			if (val <= this.total && val > 0) {
				this.eventData = this.events[val - 1];
			}
		},
	},
	created() {
		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}
	},
	mounted() {
		if (this.$route.params.id) {
			this.eventUuid = this.$route.params.id;
			setTimeout(() => {
				this.trackEvent();
			}, 200);
		}
	},
};
</script>

<style lang="scss" scoped>
.bg-search {
	background-image: url("../../assets/images/pages/vuexy-login-bg.jpg");
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	min-height: 100vh;
}

.img-datarutas {
	width: 100px;
	height: auto;
	transition: width 2s, top 1s, left 1s, position 1s;
}

.img-company-brand {
	width: 250px;
}

.bounce-enter-active {
	animation: bounce-in 1s;
}
.bounce-leave-active {
	animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
	0% {
		transform: scale(0);
	}
	50% {
		transform: scale(1.25);
	}
	100% {
		transform: scale(1);
	}
}
</style>
